import { EmptyStateGuideInfo } from './emptyStateGuideInfo';
import { EmptyState } from '../../bundles/subscription/view/createSubscriptionBundle/EmptyState';

type SubscriptionEmptyStateProps = {
  name: string;
  guideLink: string;
  create: () => void;
};

export const SubscriptionEmptyState = ({
  name,
  guideLink,
  create,
}: SubscriptionEmptyStateProps) => (
  <div className="w-full h-full flex flex-col gap-8 items-center">
    <EmptyStateGuideInfo
      name={name}
      type="Subscription"
      guideLink={guideLink}
    />

    <EmptyState create={create} />
  </div>
);
